import {FC, useState, createContext, useContext} from 'react'
import {useNavigate, NavigateFunction} from 'react-router-dom'
import {WithChildren} from '../../../_metronic/helpers'
import {ISelect} from '../../../coreGlobal/models/default'
import {IntervalsRoomRequest} from '../../../coreGlobal/models/room'
import {RoomOption} from './_models'
import {ProductOption} from '../../../components/ProductSelect'
import {getCategories, getFranchiseMachines, getFranchises, getProducts} from './_request'

interface IRoomFormContext {
  navigate: NavigateFunction

  franchises: ISelect[]
  getDataFranchises: () => Promise<void>

  categories: RoomOption[]
  getDataCategories: () => Promise<void>

  products: ProductOption[]
  getDataProducts: (categories: Array<number>) => Promise<void>

  machines: RoomOption[]
  getDataMachines: (franchiseId: number | null) => Promise<void>

  intervals: Array<IntervalsRoomRequest>[]
  setIntervals: React.Dispatch<React.SetStateAction<Array<IntervalsRoomRequest>[]>>

  loading: boolean
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
}

const emptyWeek = (): Array<IntervalsRoomRequest>[] =>
  [0, 1, 2, 3, 4, 5, 6].map((day) => [{day, start: '', end: ''}])

const RoomFormContext = createContext<IRoomFormContext>({} as IRoomFormContext)

const RoomFormProvider: FC<WithChildren> = ({children}) => {
  const navigate = useNavigate()
  const [franchises, setFranchises] = useState<ISelect[]>([])
  const [categories, setCategories] = useState<RoomOption[]>([])
  const [products, setProducts] = useState<ProductOption[]>([])
  const [machines, setMachines] = useState<RoomOption[]>([])
  const [intervals, setIntervals] = useState<Array<IntervalsRoomRequest>[]>(emptyWeek())
  const [loading, setLoading] = useState(false)

  const getDataFranchises = async () => {
    setFranchises(await getFranchises())
  }

  const getDataCategories = async () => {
    setCategories(await getCategories())
  }

  const getDataProducts = async (selectedCategories: Array<number>) => {
    setProducts(selectedCategories.length ? await getProducts(selectedCategories.join(',')) : [])
  }

  const getDataMachines = async (franchiseId: number | null) => {
    setMachines(franchiseId ? await getFranchiseMachines(franchiseId) : [])
  }

  return (
    <RoomFormContext.Provider
      value={{
        navigate,
        franchises,
        getDataFranchises,
        categories,
        getDataCategories,
        products,
        getDataProducts,
        machines,
        getDataMachines,
        intervals,
        setIntervals,
        loading,
        setLoading,
      }}
    >
      {children}
    </RoomFormContext.Provider>
  )
}

const useRoomForm = () => useContext(RoomFormContext)

export {RoomFormProvider, useRoomForm}
